import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import { CircularProgress } from "@mui/material";

export default function ProdutoCategoria(props) {
  const [categoriaId] = useState(Number(props.match.params.id));
  const history = props.history;
  const [carregando, setCarregando] = useState(false);
  const [categoria, setCategoria] = useState({});
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (categoriaId > 0) {
      carregarCartegoria();
    }
  }, []);

  const carregarCartegoria = () => {
    setCarregando(true);

    api
      .get("produtos/carregarCategoria", { id: categoriaId })
      .then((res) => {
        setCategoria(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar categorias");
        setCarregando(false);
      });
  };

  const salvar = (params) => {
    setCategoria(params);
    if (categoriaId > 0) {
      params.id = categoriaId;
      api
        .post("produtos/editarCategoria", params)
        .then((res) => {
          notification("success", "Categoria editada!");
          setCategoria({});
          history.push(`/app/produto-categoria`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .put("produtos/inserirCategoria", params)
        .then((res) => {
          notification("success", "Categoria inserida!");
          setCategoria({});
          history.push(`/app/produto-categoria`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fCategoria = {
    title: categoria.id
      ? "Editar categoria produto"
      : "Incluir categoria produto",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        value: categoria.nome,
        space: 6,
      },
      inativacao: {
        label: "Data de inativação",
        type: "date",
        value: categoria.inativacao,
        space: 6,
      },
    },

    submit: {
      label: "salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  return (
    <div>
      {carregando ? <CircularProgress /> : <Form formData={fCategoria} />}
    </div>
  );
}
